'use client';

import { useRouter } from 'next/navigation';
import React from 'react';

import Icon from './Icon';

export interface ClearFiltersButtonProps {
  searchQuery?: string;
  className?: string;
}

const ClearFiltersButton: React.FC<ClearFiltersButtonProps> = ({ searchQuery, className = '' }) => {
  const router = useRouter();

  const handleClearFilters = () => {
    // Clear all filters and navigate to clean search page
    const baseUrl = window.location.pathname;
    router.push(baseUrl);
  };

  return (
    <button
      type="button"
      onClick={handleClearFilters}
      className={`cursor-pointer inline-flex items-center gap-1 text-xs sm:text-sm text-red-600 hover:text-red-800 hover:bg-red-50 px-2 sm:px-3 py-1.5 rounded-full border border-red-200 hover:border-red-300 transition-all duration-200 hover:shadow-sm active:scale-95 whitespace-nowrap ${className}`}
      title="Limpiar todos los filtros"
    >
      <div>
        <Icon name="close" />
      </div>
      <div>
        <span className="hidden sm:inline">Limpiar filtros</span>
        <span className="sm:hidden">Limpiar</span>
      </div>
    </button>
  );
};

export default ClearFiltersButton;
